import Preparing from './Preparing';
export default Preparing;
